import React from "react";

import * as IconsSVG from "../../assets/iconsSVG";
import * as Styles from "./styles";

export const FlagLeadAtt = () => (
  <Styles.LabelIcon>
    <IconsSVG.InfoIcon className="info-icon" />
    <Styles.FloatText className="float-text">
      <IconsSVG.CheckWhiteIcon className="check-icon" />
      Resultados que atualizam o lead
    </Styles.FloatText>
  </Styles.LabelIcon>
);
